<mat-accordion
  [multi]="multi"
  zelisAccordion
  [stroke]="stroke"
  [dividers]="dividers"
>
  <mat-expansion-panel
    [hideToggle]="hideToggle"
    zelisExpansionPanel
    *ngFor="let datum of panelData; let i = index"
    [expanded]="expanded"
    (opened)="handleToggle('panel_toggle_open', datum.title)"
    (closed)="handleToggle('panel_toggle_close', datum.title)"
    [attr.data-cy]="'expansion-panel-' + i"
  >
    <mat-expansion-panel-header>
      <zelis-expansion-panel-header-content
        [title]="datum.title"
        [description]="datum.description"
        [expandedButtonVariant]="expandedButtonVariant"
      >
        <zelis-avatar
          *ngIf="datum.avatarSrc"
          [src]="datum.avatarSrc"
          [placeholderIcon]="'dls-illustration-stethoscope'"
          [size]="(breakpoint.isMobile | async) ? '40px' : '48px'"
        >
        </zelis-avatar>

        <zelis-button
          *ngIf="datum.buttonContent"
          class="hidden md:flex desktop-button"
          [ngClass]="{
            'external-link-indicator': datum.external_link_indicator
          }"
          [color]="buttonColor"
          [variant]="buttonVariant"
          [href]="datum.href || ''"
          [target]="datum.target || ''"
          (clickFn)="handleClick($event, datum.title)"
        >
          {{ datum.buttonContent }}
        </zelis-button>

        <mat-icon
          *ngIf="rightIconName"
          zelisExpansionPanelRightIcon
          [svgIcon]="rightIconName"
        ></mat-icon>
      </zelis-expansion-panel-header-content>
    </mat-expansion-panel-header>

    <div data-cy="expansion-panel-content" class="text-base">
      <span *ngIf="!expansionPanelContent" [innerHtml]="datum.content"></span>
      <ng-container
        [ngTemplateOutlet]="expansionPanelContent"
        [ngTemplateOutletContext]="{ $implicit: datum }"
      ></ng-container>
    </div>

    <zelis-button
      *ngIf="datum.buttonContent"
      class="flex mt-6 md:hidden mobile-button"
      [nowrap]="false"
      [forwardedClass]="'h-fit'"
      [ngClass]="{ 'external-link-indicator': datum.external_link_indicator }"
      [fullWidth]="true"
      [color]="buttonColor"
      [variant]="buttonVariant"
      [href]="datum.href || ''"
      [target]="datum.target || ''"
      (clickFn)="handleClick($event, datum.title)"
    >
      {{ datum.buttonContent }}
    </zelis-button>
  </mat-expansion-panel>
</mat-accordion>
